import { LogoutButton } from "@components/auth/Logout";
import { AdaptiveIconsList } from "@components/sessionManagment/AdaptiveIconsList";
import { NewSessionModal } from "@components/sessionManagment/NewSessionModal";
import { SessionSelection } from "@components/sessionManagment/SessionSelection";
import { Toolbar, makeStyles, tokens } from "@fluentui/react-components";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles({
  panel_header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: "60px",
    maxHeight: "60px",
    minWidth: "300px",
    borderBottom: "solid 1px",
    borderBottomColor: "lightgray",
    backgroundColor: tokens.colorNeutralBackground3,
    overflow: "hidden",
  },
  centerSection: {
    display: "flex",
    flexGrow: 1,
    justifyContent: "center",
    minWidth: "250px",
  },
});

interface HeaderProps {
  onScreenChange: (screen: string) => void;
}

export const Header: React.FC<HeaderProps> = ({ onScreenChange }) => {
  const styles = useStyles();
  const location = useLocation();
  const [addingSession, setAddingSession] = useState<string[] | null>(null);

  const currentScreen = location.pathname.substring(1) || "chat";

  const closeAddSessionModal = () => setAddingSession(null);

  return (
    <div className={styles.panel_header}>
      <Toolbar size="medium">
        <AdaptiveIconsList onScreenChange={onScreenChange} currentScreen={currentScreen} />
      </Toolbar>
      <div className={styles.centerSection}>
        <SessionSelection compact setAddingSession={setAddingSession} />
      </div>
      <LogoutButton />
      {!!addingSession && (
        <NewSessionModal
          onCancel={closeAddSessionModal}
          onCreated={closeAddSessionModal}
          startingInput={addingSession[0]}
        />
      )}
    </div>
  );
};
